import PropTypes from 'prop-types';
import React from 'react';
import { findSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { Breadcrumb } from '@bingads-webui-react/breadcrumb';
import { StyledMenuItemTag } from '@bingads-webui-react/menu-item-tag';

const isLeafNode = item => item && item.children.length === 0 && item.selected === true;
export class SimpleBreadcrumb extends React.PureComponent {
  render() {
    const {
      maxDisplayedItems,
      selectedItem,
      breadCrumbText,
      i18n,
      breadcrumbUrl,
      additionalPrefixItems, // shown before the main breadcrumb item
      additionalItems,
      onClick,
      showTag,
      tagClass,
    } = this.props;

    let selectedChild;
    if (selectedItem) {
      selectedChild = findSiteMap([selectedItem], isLeafNode);
    }
    const standardItems = (breadCrumbText !== null || selectedChild != null) ? [
      {
        key: breadCrumbText !== null ? breadCrumbText : selectedChild.id,
        text: breadCrumbText !== null ? breadCrumbText : i18n.getString(selectedChild.name),
        isCurrentItem: true,
        url: breadcrumbUrl,
        onClick,
      },
    ] : [];

    const items = (additionalPrefixItems || []).concat(standardItems).concat(additionalItems || []);

    return (
      <div className="summary-bar-breadcrumb">
        <Breadcrumb items={items} maxDisplayedItems={maxDisplayedItems} />
        {
          showTag && (
            <span className="summary-bar-tag">
              <StyledMenuItemTag i18n={i18n} tagContent={showTag} tagClass={tagClass} />
            </span>
          )
        }
      </div>
    );
  }
}

SimpleBreadcrumb.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  maxDisplayedItems: PropTypes.number.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
  }),
  breadCrumbText: PropTypes.string,
  breadcrumbUrl: PropTypes.string,
  additionalItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })),
  additionalPrefixItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })),
  onClick: PropTypes.func,
  showTag: PropTypes.string,
  tagClass: PropTypes.string,
};

SimpleBreadcrumb.defaultProps = {
  breadCrumbText: null,
  selectedItem: null,
  breadcrumbUrl: null,
  additionalItems: [],
  additionalPrefixItems: [],
  onClick: null,
  showTag: '',
  tagClass: '',
};
